export enum QUERY_KEYS {
  addAdmissionFloorplanPreset = 'add-admission-floorplan-preset',
  createFloorplanPreset = 'create-floorplan-preset',
  createFloorplanPresetImage = 'create-floorplan-preset-image',
  deleteFloorplanPreset = 'delete-floorplan-preset',
  deleteFloorplanPresetApply = 'delete-floorplan-preset-apply',
  deleteFloorplanPresetPreview = 'delete-floorplan-preset-preview',
  duplicateFloorplanPreset = 'duplicate-floorplan-preset',
  editFloorplanPreset = 'edit-floorplan-preset',
  getFloorplan = 'get-floorplan',
  getFloorplanPresetAdmissions = 'get-floorplan-preset-admissions',
  getFloorplanPresets = 'get-floorplan-presets',
  getFloorplanPresetSchema = 'get-floorplan-preset-schema',
  getFloorplanPresetStats = 'get-floorplan-preset-stats',
  getFloorplanPresetViewportSnapshot = 'get-floorplan-preset-viewport-snapshot',
  orderOffer = 'order-offer',
  saveFloorplanPresetSchema = 'save-floorplan-preset-schema',
  saveFloorplanPresetViewportSnapshot = 'save-floorplan-preset-viewport-snapshot',
  unassignBottleService = 'unassign-bottle-service',
}
